import { Injectable } from '@angular/core';

import {Router} from '@angular/router';
import {DataService} from '../data.service';
import {environment} from '../../environments/environment';
import { BaseAuthService } from '../auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService extends BaseAuthService {

  constructor (
    public router: Router,
    public dataService: DataService,
  ) {
    super(router, dataService);
  }

  sessionStorageTokenName = environment.projectName + '_token';
  meUrl = '/salonexpert-business/user/me';

  setToken(token, callback?) {
    if (typeof localStorage !== 'undefined') {
      sessionStorage.setItem(this.sessionStorageTokenName, token);
      this.getMe();

      if (callback) {
        callback();
      }
    }
  }

  getToken() {
    if (typeof localStorage !== 'undefined') {
      return sessionStorage.getItem(this.sessionStorageTokenName);
    }
  }
}
